import { Button, Modal } from 'rsuite';
import styles from './DeleteCampaign.module.scss';

type CampaignTypeDeleteModalProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  campaignsName: string[];
};

export const CampaignTypeDeleteModal = ({ open, onCancel, onConfirm, campaignsName }: CampaignTypeDeleteModalProps) => {
  const isAllowed = campaignsName.length === 0;

  return (
    <Modal show={open} onHide={onCancel} className={styles.modal} size="sm" keyboard>
      <Modal.Body>
        <div className={`${styles.iconWrap} ${isAllowed ? styles.iconWarning : styles.iconError}`} aria-hidden>
          {isAllowed ? '!' : '×'}
        </div>

        <h3 className={styles.title}>Excluir tipo de campanha</h3>

        {isAllowed ? (
          <p className={styles.textCenter}>
            Você está deletando um tipo de campanha, essa ação é irreversível.
            <span className={styles['text-bold']}> Você tem certeza que quer prosseguir?</span>
          </p>
        ) : (
          <>
            <p className={styles.textCenter}>
              Você não pode excluir este tipo de campanha pois ela contém
              <br />
              campanhas vigentes ou programadas.
            </p>
            <p className={styles.textCenter}>
              Para prosseguir com a exclusão,{' '}
              <span className={styles['text-bold']}>
                você precisa editar ou inativar
                <br />
                as campanhas associadas primeiro:
              </span>
            </p>
            <ul className={styles.associatedList}>
              {campaignsName.map(c => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </>
        )}
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <Button appearance="ghost" onClick={onCancel} className={styles.btnGhost}>
          Cancelar
        </Button>

        {isAllowed && (
          <Button
            appearance="primary"
            onClick={() => {
              onConfirm();
              onCancel();
            }}
            className={styles.btnPrimary}
          >
            Excluir
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
